import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Scale, MessageCircle, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import ContactPopup from './ContactPopup';

const LandingPageHeader = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-50 bg-slate-900/95 backdrop-blur-md border-b border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <div className="flex items-center">
              <img 
                src="/logo-white.png" 
                alt="Global Filing Protection®" 
                className="h-10 w-auto"
              />
            </div>

            {/* Action Buttons */}
            <div className="flex items-center space-x-2 sm:space-x-3">
              <a 
                href="tel:+18332020812"
                className="hidden lg:flex items-center text-amber-500 hover:text-amber-400 font-semibold transition-colors"
              >
                <Phone className="h-4 w-4 mr-1" />
                <span className="text-xs">+1-833-202-0812</span>
              </a>
              <a 
                href="mailto:info@globalfilingprotection.com"
                className="hidden lg:flex items-center text-amber-500 hover:text-amber-400 font-semibold transition-colors"
              >
                <Mail className="h-4 w-4 mr-1" />
                <span className="text-xs">info@globalfilingprotection.com</span>
              </a>
              <Button 
                onClick={() => setIsPopupOpen(true)}
                variant="outline"
                className="border-2 border-white/60 text-amber-500 hover:bg-amber-500/10 font-semibold hidden sm:flex text-xs sm:text-sm"
              >
                Register My Trademark
              </Button>
              <Button 
                onClick={() => {
                  if (window.zE) {
                    window.zE('webWidget', 'open');
                  }
                }}
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold shadow-lg transform transition-transform hover:scale-105 chat-button text-xs sm:text-sm"
              >
                <MessageCircle className="h-4 w-4 sm:h-5 sm:w-5 mr-1 sm:mr-2" />
                Chat Now
              </Button>
            </div>
          </div>
        </div>
      </header>

      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
};

export default LandingPageHeader;
